import type { MenuLink } from "core-fe-lib/components-shadcn/types/menu-link";
import { Role } from "core-fe-lib/openapi/core/models/Role";

export function getArchitectKeyLinks(t: (k: string) => string): MenuLink[] {
  return [
    {
      title: t("architectkey.title"),
      caption: t("architectkey.caption"),
      icon: "key",
      hasExpansion: true,
      items: [
        {
          title: t("architectkey.menuTitle"),
          icon: "key",
          link: "/architect-keys",
          requiredPrivilege: Role.USER,
        },
      ],
    },
  ];
}
